import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from '../../../components/layout/header/Header';
import { usePopup } from '../../../components/common/Popup';
import PaginaRelatorio from '../../../components/features/relatorioConcessao/PaginaRelatorio';
import DetalheRelatorio from '../../../components/features/relatorioConcessao/DetalheRelatorio';
import { RELATORIOS_CONCESSAO } from '../../../components/features/relatorioConcessao/constantes';
import { BotaoPdf, Mensagem } from '../../../components/features/relatorioConcessao/estilos';
import apiService from '../../../services/api';
import statistics from '../../../assets/statistics.png';

const RelatorioConcessaoDetalhe = () => {
  const { relatorio, solicitacaoId } = useParams();
  const definicao = RELATORIOS_CONCESSAO[relatorio];
  const navigate = useNavigate();
  const location = useLocation();
  const popup = usePopup();
  const [gerandoPdf, setGerandoPdf] = useState(false);

  const voltar = () => navigate(location.state?.voltarPara ?? `/RelatorioConcessao/${relatorio}`);

  const gerarPdf = async () => {
    setGerandoPdf(true);
    try {
      await apiService.downloadRelatorioConcessaoDetalhePdf(relatorio, solicitacaoId);
    } catch (erro) {
      await popup.alert({ icon: 'warning', title: 'Não foi possível gerar o PDF', message: erro.message });
    } finally {
      setGerandoPdf(false);
    }
  };

  if (!definicao) {
    return (
      <PaginaRelatorio>
        <Mensagem>Relatório não encontrado.</Mensagem>
      </PaginaRelatorio>
    );
  }

  return (
    <PaginaRelatorio>
      <Header
        prefixText="RELATÓRIO DE CONCESSÃO"
        icon={statistics}
        title={definicao.titulo}
        acoes={
          <BotaoPdf type="button" onClick={gerarPdf} disabled={gerandoPdf}>
            {gerandoPdf ? 'Gerando...' : 'Gerar pdf'}
            <span className="material-symbols-outlined">picture_as_pdf</span>
          </BotaoPdf>
        }
      />
      <DetalheRelatorio relatorio={relatorio} solicitacaoId={solicitacaoId} onVoltar={voltar} />
    </PaginaRelatorio>
  );
};

export default RelatorioConcessaoDetalhe;
